export default "__VITE_ASSET__Bokw$Y76__"